module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Regular.a73b1b26.woff";